import { ShieldCheck, Truck, HeadphonesIcon } from "lucide-react";

const advantages = [
  {
    icon: ShieldCheck,
    title: "Produits certifiés",
    description: "Tous nos compléments sont certifiés et testés pour garantir qualité et efficacité.",
  },
  {
    icon: Truck,
    title: "Livraison en Côte d'Ivoire",
    description: "Livraison rapide et sécurisée dans toutes les villes de Côte d'Ivoire.",
  },
  {
    icon: HeadphonesIcon,
    title: "Conseil personnalisé",
    description: "Notre équipe d'experts santé vous accompagne dans le choix de vos produits.",
  },
];

export default function Advantages() {
  return (
    <section data-testid="advantages-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 fade-up">
          <h2
            className="text-3xl md:text-4xl font-semibold text-stone-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Pourquoi nous choisir ?
          </h2>
          <p className="text-base md:text-lg text-stone-600 max-w-xl mx-auto">
            Votre santé mérite le meilleur. Nous nous engageons à vous offrir des produits d'exception.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {advantages.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`advantage-card-${index}`}
                className={`fade-up fade-up-delay-${index + 1} group text-center p-8 rounded-2xl bg-[#F5F0E8]/50 hover:bg-[#F5F0E8] transition-all duration-300 hover:shadow-lg`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#6C3FC5]/10 text-[#6C3FC5] mb-6 group-hover:bg-[#6C3FC5] group-hover:text-white transition-all duration-300">
                  <Icon size={28} />
                </div>
                <h3
                  className="text-xl font-semibold text-stone-900 mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {item.title}
                </h3>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
